import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Material-UI
import Button from '@material-ui/core/Button';

const MuiButton = (props) => {
  const {
    children,
    color,
    ...restProps
  } = props;

  return (
    <Button
      color={color}
      variant="contained"
      {...restProps}
    >
      {children}
    </Button>
  );
};

MuiButton.propTypes = {
  // The content of the button.
  children: PropTypes.node.isRequired,
  // The color of the component. It supports those theme colors that make sense for this component.
  color: PropTypes.oneOf(['primary', 'secondary']),
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

// Button Label
const StyledButtonLabel = styled(MuiButton)`
  .MuiButton-label {
    font-family: 'Bryant Pro Regular';
    font-size: ${(props) => props.theme.typography.bodyText};
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    text-transform: none;
  }
`;

// Button CTA (Call To Action)
export const StyledButtonCTA = styled(StyledButtonLabel)`
  &.MuiButton-root {
    min-height: 40px;
    min-width: 110px;
    padding: 8px;
    margin: ${(props) => props.margin === 'false' ? '0px' : '8px'};
    border-radius: 6px;
    box-shadow: ${(props) => props.theme.shadows.depth1};
  }

  &.MuiButton-containedPrimary {
    color: ${(props) => props.theme.colors.white};
    background-color: ${(props) => props.theme.colors.blueMedium};
    &:hover {
      background-color: ${(props) => props.theme.colors.blueDark};
      box-shadow: ${(props) => props.theme.shadows.depth2};
    }
  }

  &.MuiButton-containedSecondary {
    color: ${(props) => props.theme.colors.white};
    background-color: ${(props) => props.theme.colors.red};
    &:hover {
      background-color: ${(props) => props.theme.colors.redDark};
      box-shadow: ${(props) => props.theme.shadows.depth2};
    }
  }

  &.MuiButton-contained.Mui-disabled {
    color: ${(props) => props.theme.colors.greyMedium};
    box-shadow:  ${(props) => props.theme.shadows.depth1};
    background-color: rgba(0, 0, 0, 0.12);
  }
`;

// Button Link
export const StyledButtonLink = styled(StyledButtonLabel)`
  &.MuiButton-root {
    min-height: 40px;
    padding: 0px;
    color: ${(props) => props.theme.colors.blueDark};
    background: none;
    box-shadow: none;
    &:hover {
      text-decoration: underline;
      background: none;
      box-shadow: none;
    }
  }
`;

// Button Text
export const StyledButtonText = styled(StyledButtonLabel)`
  &.MuiButton-root {
    min-height: 40px;
    min-width: 110px;
    padding: 8px;
    margin: ${(props) => props.margin === 'false' ? '0px' : '8px'};
    color: ${(props) => props.theme.colors.greyDark};
    background: none;
    box-shadow: none;
    &:hover {
      text-decoration: underline;
      background: none;
      box-shadow: none;
    }
  }
`;